/**
 * TODO: this composable can be extended with keeping track of the current step etc.
 */
export default function useProgressBar() {
  const { t } = useI18n();

  const progressBarSteps = [
    t("website.progressbar.hotel.information.label"),
    t("website.progressbar.hotel.rates.label"),
    t("website.progressbar.hotel.addons.label"),
    t("website.progressbar.hotel.details.label"),
    t("website.progressbar.hotel.payment.label"),
  ];

  return {
    progressBarSteps,
  };
}
